import { notification as antdStatic } from 'antd';

let instance = null;

export function registerAppNotification(api) {
  instance = api;
}

export function unregisterAppNotification() {
  instance = null;
}

function normalizeConfig(config) {
  const { message, title, description, ...rest } = config;
  const heading = message ?? title ?? '';
  return {
    ...rest,
    message: heading,
    title: heading,
    description,
  };
}

function getApi() {
  return instance ?? antdStatic;
}

export const appNotification = {
  error: config => getApi().error(normalizeConfig(config)),
  success: config => getApi().success(normalizeConfig(config)),
  info: config => getApi().info(normalizeConfig(config)),
  warning: config => getApi().warning(normalizeConfig(config)),
  close: key => getApi().close(key),
};
